// extracted by mini-css-extract-plugin
module.exports = {"lightBlue":"BillingDetailsTable_lightBlue__1Mzxh","root":"BillingDetailsTable_root__2R3jE","item":"BillingDetailsTable_item__2999y","title":"BillingDetailsTable_title__20BYT"};